import './Modal.css';
import {useEffect} from 'react';

export default function Modal({ isOpen, onClose, children }) {

    useEffect(() => {
        if (!isOpen) return;

        const html = document.documentElement;
        const body = document.body;
        const root = document.getElementById('root');
        const app = document.querySelector('.app');

        const elementsToLock = [html, body, root, app];

        elementsToLock.forEach(el => {
            if (el) el.style.overflow = 'hidden';
        });

        return () => {
            elementsToLock.forEach(el => {
                if (el) el.style.overflow = '';
            });
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-box" onClick={e => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
}
